import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { ChevronRight } from 'react-feather';
import { Typography } from '@oca/ui';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 4px;
`;

const List = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const HomeButton = styled(Link)`
  width: 26px;
  height: 26px;
  border-radius: 6px;
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CrumbLink = styled(Link)`
  text-decoration: none;
  color: #2f3b52;
  background: #e8e8e8;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
`;

const CurrentCrumb = styled.span`
  color: #2f3b52;
  background: #e8e8e8;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
`;

const Separator = styled(ChevronRight)`
  color: #d0d5dd;
  width: 14px;
  height: 14px;
`;

const routeLabels = {
  '/': 'Dashboard',
  '/projects': 'Projects',
  '/tasks': 'Tasks',
  '/meetings': 'Meetings',

  '/hr': 'HR',
  '/hr/employees': 'Employees',
  '/hr/attendance': 'Attendance',
  '/hr/leaves': 'Leaves',
  '/hr/allowances': 'Allowances',
  '/hr/events': 'Events',
  '/hr/public-holidays': 'Public holidays',

  '/documents': 'Documents',
  '/documents/my-files': 'My Files',
  '/documents/favorite': 'Favorite',
  '/documents/shared-with-me': 'Shared with me',
  '/documents/shared-by-me': 'Shared by me',
  '/documents/company-files': 'Company Files',
};

export function AppBreadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  const crumbs = pathnames.map((_, index) => {
    const url = `/${pathnames.slice(0, index + 1).join('/')}`;
    return {
      url,
      label:
        routeLabels[url] ||
        pathnames[index]
          .replace(/-/g, ' ')
          .replace(/\b\w/g, char => char.toUpperCase()),
    };
  });

  return (
    <Wrapper>
      <List>
        <HomeButton to="/">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.7494 16.7871C12.7494 17.2011 12.4134 17.5371 11.9994 17.5371C11.5854 17.5371 11.2494 17.2011 11.2494 16.7871V12.6771C11.2494 12.2631 11.5854 11.9271 11.9994 11.9271C12.4134 11.9271 12.7494 12.2631 12.7494 12.6771V16.7871ZM19.9194 7.62505L14.3464 3.08605C12.9864 1.97605 11.0124 1.97505 9.6544 3.08505L4.0824 7.62405C3.2114 8.33005 2.7124 9.37705 2.7124 10.4971V17.6771C2.7124 19.9211 4.5394 21.7471 6.7844 21.7471H17.2154C19.4604 21.7471 21.2874 19.9211 21.2874 17.6771V10.4971C21.2874 9.37705 20.7884 8.33005 19.9194 7.62505Z"
              fill="#64748B"
            />
          </svg>
        </HomeButton>

        {location.pathname === '/' && (
          <Typography
            color="textSecondary"
            style={{ fontSize: 14, fontWeight: 500 }}
          >
            Dashboard
          </Typography>
        )}

        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;

          return (
            <React.Fragment key={crumb.url}>
              <Separator />
              {isLast ? (
                <CurrentCrumb>{crumb.label}</CurrentCrumb>
              ) : (
                <CrumbLink to={crumb.url}>{crumb.label}</CrumbLink>
              )}
            </React.Fragment>
          );
        })}
      </List>
    </Wrapper>
  );
}
